console.log('✅ VISOOK SCROLL FILE LOADED');

window.addEventListener('load', function () {
  const panels = document.querySelectorAll('.visook-video-panel');
  const videos = document.querySelectorAll('.visook-video-panel video');

  console.log('VISOOK VIDEO PANELS:', panels.length);
  console.log('VISOOK VIDEOS:', videos.length);

  panels.forEach(function(panel){
    panel.style.outline = '4px solid red';
  });

  videos.forEach(function(video){
    video.style.transform = 'scale(1.15)';
    video.style.transition = 'transform 1s ease';
  });
});